const { createBundleTiles } = require('../tiles/product-tile-factory'),
    { mergeInspirationTiles } = require('../tiles/merge-inspiration-tiles'),
    { filter, isUndefined } = require('lodash');

class BrowseTileListController {
    constructor($scope, $timeout, $location, settings, analyticsService, breakpointsService, pageMetadataService, richRelevanceService, shelfProductService, sortByKeys, pageBannerStateService, categoriesService) {
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$location = $location;
        this.settings = settings;
        this.analyticsService = analyticsService;
        this.breakpointsService = breakpointsService;
        this.pageMetadataService = pageMetadataService;
        this.richRelevanceService = richRelevanceService;
        this.shelfProductService = shelfProductService;
        this.sortByKeys = sortByKeys;
        this.pageBannerStateService = pageBannerStateService;
        this.categoriesService = categoriesService;
    }

    $onInit() {
        this.sortOptions = this.category.IsSortEnabled ? {
            sortTypes: this.settings[this.category.IsSpecial ? 'specials' : 'browse'].sortOptions,
            sortContext: this.category.IsSpecial ? this.sortByKeys.SPECIALS_KEY : this.sortByKeys.BROWSE_KEY,
        } : null;
        this.hasToken = !isUndefined(this.token);
        this.breadcrumbs = this.categoriesService.getCategoryPathToToRootByNodeId(this.category.NodeId);
    }

    createTiles(response, pageSize, pageNumber) {
        return {
            items: mergeInspirationTiles(createBundleTiles(response.Bundles), response.InspirationCards ? response.InspirationCards.Cards : null, { pageSize, pageNumber }),
            totalRecordCount: response.TotalRecordCount,
            aggregations: filter(response.Aggregations, a => a.ShowFilter),
        };
    }

    getTiles(pageSize, pageNumber, sortType, filters) {
        return this.getBrowsePage(pageSize, pageNumber, sortType, filters)
            .then(response => this.setMetadata(response))
            .then(response => this.onPlacementsReceived(response))
            .then(response => this.pushAnalytics(pageNumber, sortType, filters, response))
            .then(response => this.rewardsCheck(response))
            .then(response => this.tobaccoCheck(response))
            .then(response => this.createTiles(response, pageSize, pageNumber));
    }

    getBrowsePage(pageSize = 10, pageNumber, sortType, filters) {
        return this.shelfProductService.getBrowsePage({
            categoryId: this.category.IsBundle ? this.category.ParentNodeId : this.category.NodeId,
            pageNumber,
            pageSize,
            sortType,
            url: this.$location.url(),
            location: this.$location.path(),
            formatObject: JSON.stringify({ name: this.category.Description }),
            isSpecial: this.category.IsSpecial,
            isBundle: this.category.IsBundle,
            isMobile: this.breakpointsService.isInSmallFormat,
            filters: filters ? filters.filters : null,
            token: this.token,
        });
    }

    setMetadata(response) {
        this.pageMetadataService.setMetadata(response.SeoMetaTags);

        return response;
    }

    onPlacementsReceived(response) {
        if (this.richRelevanceService.useServerSideResults(response.RichRelevancePlacement)) {
            this.richRelevanceService.onPlacementsReceived(response.RichRelevancePlacement);
        }

        return response;
    }

    pushAnalytics(pageNumber, sortType, filters, response) {
        this.analyticsService.push({
            data: {
                pageNumber,
                currentCategory: this.category,
                products: response.Bundles,
                inspirationCards: response.InspirationCards,
                totalRecordCount: response.TotalRecordCount,
                filters,
                sortType,
                sortOptions: this.sortOptions,
            },
            type: this.analyticsService.mapperTypes.shop.productCategory,
        });

        return response;
    }

    rewardsCheck(response) {
        // BE logic - hasRewardsCard is true always except for 'Logged in user with no rewards card tagged and navigated to My weekly picks page'.
        this.hasRewardsCard = response.HasRewardsCard;
        this.rewardsSuccess = response.Success;
        return response;
    }

    tobaccoCheck(response) {
        this.pageBannerStateService.setTobaccoBanner(response.HasTobaccoItems);

        return response;
    }
}

BrowseTileListController.$inject = ['$scope', '$timeout', '$location', 'Settings', 'AnalyticsService', 'BreakpointsService', 'PageMetadataService', 'RichRelevanceService', 'ShelfProductService', 'SortByKeys', 'PageBannerStateService', 'CategoriesService'];

const browseTileListComponentDefinition = {
    bindings: {
        category: '<',
        pageNumber: '<',
        sortBy: '<',
        filter: '<',
        token: '<',
    },
    controller: BrowseTileListController,
    template: require('./browse-tile-list.component.html').trim(),
};

module.exports = {
    BrowseTileListController,
    browseTileListComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/browse/browse-tile-list.component.js